(function () {
  'use strict';

  angular.module('sempraWebapp').component('logsEvents', {
    templateUrl: 'app/facilityKarcherDetails/logsEvents/logsEvents.html',
    controller: logsEvents,
    bindings: {
      eventData: '<',
      deviceSerial: '<',
      pullNewData: '&'
    },
    controllerAs: 'vm'
  });

  function logsEvents() {
    var vm = this;

    vm.deviceEventDataList = null;

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      if (changes.eventData) {
        changes.eventData.currentValue ? changes.eventData.currentValue.data.forEach(function(item) {
          item.newTimestamp = moment(item.timestamp, 'YYYY-MM-DD hh:mm:ss').format('LLL');
        }) : null;
        vm.deviceEventDataList = changes.eventData.currentValue;
      }
    };

    vm.refreshLogPage = function () {
      vm.pullNewData();
    };
  }
})();
